"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useFloatingHideListeners", {
    enumerable: true,
    get: function() {
        return useFloatingHideListeners;
    }
});
const _react = require("react");
const _FocusTrapContext = require("../contexts/FocusTrapContext");
const useFloatingHideListeners = (param)=>{
    let { onHide, floating } = param;
    const { ref: focusRef } = (0, _react.useContext)(_FocusTrapContext.FocusTrapContext);
    (0, _react.useEffect)(()=>{
        const onClick = (e)=>{
            var _f_refs_reference_current, _f_refs_floating_current;
            const target = e.target;
            const f = floating;
            // ignore clicks on detached elements
            if (!target.isConnected) {
                return;
            }
            if (f.refs.reference.current !== target && ((_f_refs_reference_current = f.refs.reference.current) === null || _f_refs_reference_current === void 0 ? void 0 : _f_refs_reference_current.contains(target)) === false && ((_f_refs_floating_current = f.refs.floating.current) === null || _f_refs_floating_current === void 0 ? void 0 : _f_refs_floating_current.contains(target)) === false) {
                onHide();
            }
        };
        const onEsc = (e)=>{
            if (e.key === "Escape") {
                onHide();
            }
        };
        const focusEl = focusRef.current;
        if (focusEl != null) {
            focusEl.addEventListener("click", onClick);
            focusEl.addEventListener("keyup", onEsc);
        }
        window.addEventListener("click", onClick);
        window.addEventListener("keyup", onEsc);
        return ()=>{
            window.removeEventListener("click", onClick);
            window.removeEventListener("keyup", onEsc);
            if (focusEl != null) {
                focusEl.removeEventListener("click", onClick);
                focusEl.removeEventListener("keyup", onEsc);
            }
        };
    }, [
        onHide,
        floating,
        focusRef
    ]);
};

//# sourceMappingURL=useFloatingHideListeners.js.map